import { render, staticRenderFns } from "./FreeboardComments.vue?vue&type=template&id=4b9b9568"
import script from "./FreeboardComments.vue?vue&type=script&lang=js"
export * from "./FreeboardComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports